export function compileFactory(el, scope, ecFormBuilderController, $compile, $timeout) {
  let childScope;

  return function compile(html = '', path = '', parentScope = {}) {
    return new Promise(resolve => {
      destroy().then(() => {
        if (!path) {
          el.innerHTML = html;
          resolve();
          return;
        }
        // childScope = scope.$new(true, parentScope);
        childScope = scope.$new(true, scope);
        Object.assign(childScope, parentScope);
        ecFormBuilderController.bind(childScope, path);
        el.innerHTML = html;
        $compile(el)(childScope);
        $timeout(() => resolve());
      });
    });

    function destroy() {
      if (!childScope) {
        return Promise.resolve();
      }
      return new Promise(resolve => {
        childScope.$destroy();
        $timeout(() => resolve());
      });
    }
  };
}
